#chat-item-container {
  display: flex;
  gap: 15px;
}

:host {
  width: fit-content;
  max-width: 90%;
  opacity: 0;
  transform: translateY(10px);
  animation: slideIn 0.4s ease forwards;
}

@keyframes slideIn {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.message-content {
  padding: 10px 16px;

  ::slotted(ux-copy) {
    margin: 0;
  }
}

:host([source="bot"]) {
  display: block;

  .message-content {
    background-color: $color-blue-4;
  }
}

:host([source="user"]) {
  .message-content {
    background-color: $color-white;
  }
}

:host([source="system"]) {
  .message-content {
    background-color: $color-black-70;

    --ux-button-text-transform: none;
    --ux-button-font-weight: 400;
    --ux-button-border-color: #{$color-blue-info};
    --ux-button-text-color: #{$color-white};
    --ux-button-bg-color: #{$color-blue-info};
    --ux-button-hover-bg-color: #{$color-white};
    --ux-button-hover-border-color: #{$color-white};
    --ux-button-hover-text-color: #{$color-black-solid};

    ::slotted(ux-copy) {
      margin-bottom: 10px;
    }
  }
}

header {
  display: flex;
  justify-content: space-between;
  font-weight: bold;
}

.profile-picture {
  width: 50px;
  height: 50px;
  flex-shrink: 0;
  border-radius: 4px;
  background-color: $color-blue-info;
  display: flex;
  justify-content: center;
  align-items: center;
  align-self: flex-start;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.user-message-footer {
  text-align: right;
}

.chat-name,
.chat-date {
  color: $color-black-solid;
  font-size: 0.625rem;
}

@media (max-width: 768px) {
  ::slotted(#feedback-button) {
    width: 100%;
  }
}